import { render, staticRenderFns } from "./newSchoolDataDetails.vue?vue&type=template&id=05772f92&scoped=true"
import script from "./newSchoolDataDetails.vue?vue&type=script&lang=js"
export * from "./newSchoolDataDetails.vue?vue&type=script&lang=js"
import style0 from "./newSchoolDataDetails.vue?vue&type=style&index=0&id=05772f92&prod&lang=scss&scoped=true"
import style1 from "./newSchoolDataDetails.vue?vue&type=style&index=1&id=05772f92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05772f92",
  null
  
)

export default component.exports